import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import BrandAccessRightsList from './components/BrandAccessRightsList';

export function BrandAccessRoutes() {
    return <Routes>{hasAccessRight(AdminAclEnum.BRAND_USER_ACCESS_RIGHTS) && <Route index element={<BrandAccessRightsList />} />}</Routes>;
}
